import { BaseFeature, FeatureType } from '@core/shared/feature';
export class MpfAppBaseFeature extends BaseFeature {
  static {
    this.featureInfo = {
      dependencies: ['common-task-scheduler'],
      context: {"package":"@mpf/app/feature","featureId":"mpf-app"},
      abilityActions: false,
      plugins: [{
        forPlatform: 'frontend',
        type: FeatureType.Permanent,
        pluginClassName: 'MpfAppFrontendFeature'
      }, {
        forPlatform: 'frontend',
        type: FeatureType.Permanent,
        pluginClassName: 'MpfAppFrontendManagementFeature',
        importFrom: 'frontend-management'
      }, {
        forPlatform: 'admin',
        type: FeatureType.Permanent,
        pluginClassName: 'MpfAppFrontendAdminFeature'
      }
      // {forPlatform:'backend', type:FeatureType.Permanent, pluginClassName:'MpfAppBackendFeature'},
      ]
    };
  }
  getSharedDefinition() {
    return {
      routerLinkResolvers: {
        frontend: {
          'demo': () => '/request-demo',
          'request-demo': () => '/request-demo',
          'management-dashboard': () => '/management/dashboard'
        }
      }
    };
  }
}